import {
  SET_BUTTON_PROCESSING,
  CLEAR_BUTTON_PROCESSING,
  RESET_BUTTON_PROCESSING,
} from "../../constants/actionTypes";

const setButtonProcessing = (buttonId) => {
  return {
    type: SET_BUTTON_PROCESSING,
    payload: buttonId,
  };
};

const clearButtonProcessing = (buttonId) => {
  return {
    type: CLEAR_BUTTON_PROCESSING,
    payload: buttonId,
  };
};

const resetButtonProcessing = () => {
  return {
    type: RESET_BUTTON_PROCESSING,
    payload: null,
  };
};

export { setButtonProcessing, clearButtonProcessing, resetButtonProcessing };
